import { createReactComponent } from '@tabler/icons-react';

export const IconCustomMenuUp = createReactComponent(
  'outline',
  'customMenuUp',
  'CustomMenuUp',
  [
    [
      'path',
      {
        key: 'customMenuUp-path',
        d: 'M8.7,13.5l3.3-3.2,3.3,3.3',
      },
    ],
  ]
);
